import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { getPage, siteUrl } from '../content/discovery';

export default function SearchMetadata() {
  const { pathname, search } = useLocation();
  const page = getPage(pathname);
  // DropInBlog owns article metadata. Preserve its article query in the canonical
  // instead of collapsing every article onto /blogs; ignore tracking parameters.
  const post = pathname === '/blogs' ? new URLSearchParams(search).get('p') : null;
  const canonical = post ? `${siteUrl}/blogs?${new URLSearchParams({ p: post }).toString()}` : page?.url;
  if (!page) return null;
  return <Helmet htmlAttributes={{ lang: 'zh-Hant-HK' }}>
    {!post && <title>{page.title}</title>}
    {!post && <meta name="description" content={page.description} />}
    <link rel="canonical" href={canonical} />
    {!post && <meta property="og:title" content={page.title} />}
    {!post && <meta property="og:description" content={page.description} />}
    <meta property="og:url" content={canonical} />
    <meta property="og:locale" content="zh_HK" />
    <meta property="og:image" content={`${siteUrl}/logo-white.png`} />
    {!post && <script type="application/ld+json">{JSON.stringify(page.structuredData).replace(/</g, '\\u003c')}</script>}
  </Helmet>;
}
